import styled from 'styled-components';

export const SJsonViewerContainer = styled.div`
  overflow: auto;
  height: 100%;
  font-family: monospace;
  white-space: pre-wrap;
  line-height: 1.4;

  .json-viewer {
    overflow: auto;
    width: 100%;
  }

  .json-wrapper {
    display: flex;
  }

  .json-viewer .entry .key {
    margin: 5px 0;
  }

  .property {
    position: relative;
    display: block;
    margin-left: 5px;
  }

  .property-name {
    font-weight: bold;
  }

  .value {
    color: inherit;
  }

  .root-toggle-symbol {
    cursor: pointer;
    user-select: none;
    padding: 0 5px;
  }

  .toggle-symbol {
    cursor: pointer;
    user-select: none;
    position: absolute;
    left: -15px;
    padding: 0 5px;
  }

  .entry {
    margin-bottom: 5px;
  }

  .copy-button {
    margin-top: 15px;
  }
`;
